import {createRouter, createWebHistory} from 'vue-router'
import Personal from "@/router/module/personal";

const routes = [
    {
        path: "/demo",
        name: "TestDemo",
        component: () => import('../views/game/Demo')
    },
    {
        path: "/game/gid_:game_id",
        name: "game",
        component: () => import("../views/game/Play")
    },
    {
        path: "/game/gid_:game_id/pid_:promote_id",
        name: "GamePlay",
        component: () => import("../views/game/Play")
    },
    // 支付
    {
        path: '/pay/pay-spend',
        name: 'PaySpend',
        component: () => import('../views/pay/Spend')
    },
    // 悬浮球
    {
        path: '/float',
        name: 'Float',
        component: () => import('../views/Float')
    },
    ...Personal,

    //帮助中心
    {
        path: '/tool/help-center',
        name: 'ToolHelpCenter',
        component: () => import('../views/tool/HelpCenter'),
    },
    //消息列表
    {
        path: '/tool/notice-list',
        name: 'ToolNoticeList',
        component: () => import('../views/tool/NoticeList'),
    },
    //消息详情
    {
        path: '/tool/notice-detail/:notice_id',
        name: 'ToolNoticeDetail',
        component: () => import('../views/tool/NoticeDetail'),
    },
    // 错误路由
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () => import('../views/404.vue')
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,

});

export default router
